/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import '../vendors/organic-tab';
import '../vendors/slick.min';
import '../vendors/owl.carousel.min';
// import '../vendors/carousel-custom';
// import './customer-ajax-filter';
jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );
jQuery( document ).ready( function() {
	jQuery( '.mobile-show a[href^="#"]' ).on( 'click', function( event ) {
		const target = jQuery( jQuery( this ).attr( 'href' ) );
		if ( target.length ) {
			event.preventDefault();
			if ( jQuery( 'body' ).hasClass( 'have-topbar' ) ) {
				jQuery( 'html, body' ).animate( {
					scrollTop: target.offset().top - 170,
				}, 1000 );
			} else {
				jQuery( 'html, body' ).animate( {
					scrollTop: target.offset().top - 75,
				}, 1000 );
			}
		}
	} );

	const marquees = Array.from( document.querySelectorAll( '.marquee' ) );

	class Marquee {
		constructor( { el } ) {
			this.el = el;
			this.marqueeAnimation = [
				{ transform: 'translateX(0)' },
				{ transform: `translateX(calc(-100% - var(--gap,0)))` },
			];
			this.animations = [];
			this.SLOWDOWN_RATE = 0.5;
			this.cloneMarqueeGroup();
			this.init();
		}

		init() {
			for ( const m of this.marquee__groups ) {
				const itemCount = m.querySelectorAll( 'div' ).length;
				const itemWidth = m.clientWidth;
				const duration = 15 * itemWidth; // 1 second per item
				// console.log( m.querySelectorAll( 'div' ), itemCount, itemWidth, duration );
				const marqueeTiming = {
					duration,
					direction: this.el.dataset.reverse ? 'reverse' : 'normal',
					iterations: Infinity,
				};
				const q = m.animate( this.marqueeAnimation, marqueeTiming );
				this.animations.push( q );
			}

			this.initEvents();
		}

		slowDownAnimations() {
			for ( const a of this.animations ) {
				a.playbackRate = this.SLOWDOWN_RATE;
			}
		}

		resumeAnimationSpeed() {
			for ( const a of this.animations ) {
				a.playbackRate = 1; // Resume normal playback rate
			}
		}

		cloneMarqueeGroup() {
			const marqueeGroups = this.el.querySelectorAll( '.marquee__group' );

			marqueeGroups.forEach( ( group ) => {
				const items = group.querySelectorAll( 'div' );
				const itemCount = items.length;
				const cloneCount = itemCount < 5 ? 2 : 1;

				for ( let i = 0; i < cloneCount; i++ ) {
					items.forEach( ( item ) => {
						const clonedItem = item.cloneNode( true );
						group.appendChild( clonedItem );
					} );
				}
			} );

			const firstGroup = this.el.querySelector( '.marquee__group' );
			const clone = firstGroup.cloneNode( true );
			clone.classList.add( 'clone' );
			this.el.appendChild( clone );

			this.marquee__groups = Array.from( this.el.querySelectorAll( '.marquee__group' ) );
		}
	}

	for ( const m of marquees ) {
		new Marquee( { el: m } );
	}
} );
jQuery( function() {
	function addClassToParent() {
		jQuery( '.owl-carousel' ).each( function() {
			const parentSection = jQuery( this ).closest( 'section' );

			if ( parentSection.length > 0 ) {
				parentSection.addClass( 'overflow-hidden' );
			}
		} );
	}
	addClassToParent();

	jQuery( '.role-marquee' ).owlCarousel( {
		autoplay: true,
		lazyLoad: true,
		items: 12,
		loop: true,
		margin: 40,
		autoWidth: true,
		responsiveClass: true,
		slideTransition: 'linear',
		autoplayTimeout: 8000,
		autoplaySpeed: 8000,
		nav: false,
		dots: false,
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() > 373 && jQuery( window ).width() < 748 ) {
	// If the window width is less than 748 pixels

		// Select the .fcta-button element
		const $buttonElement = jQuery( '.fcta-button' );

		// Append it inside .cta-heading after h3.heading-3
		jQuery( '.cta-heading .heading-2' ).after( $buttonElement );

		const $stripesElement = jQuery( '.hero-customer .brand-stripes' );

		// Append it inside .cta-heading after h3.heading-3
		jQuery( '.hero-customer .hero-text-inner' ).after( $stripesElement );
	}

	jQuery.noConflict();

	jQuery( '.top-search' ).click( function() {
		jQuery( this ).parent( ).parent( ).addClass( 'search-ctn' );
		jQuery( '.search-form-new' ).slideDown();
	} );

	jQuery( '.search-close-btn' ).click( function() {
		jQuery( '.menu-search' ).removeClass( 'search-ctn' );
		jQuery( '.search-form-new' ).slideUp();
	} );

	jQuery.noConflict();

	jQuery( '.hero-team,.team-members' ).organicTabs( {
		speed: 200,
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.mobile-post-title' ).on( 'click', function() {
			const $accordion = jQuery( this ).closest( '.mobile-accordian' );
			const $content = $accordion.find( '.mobile-posts' );

			if ( $accordion.hasClass( 'active' ) ) {
				$accordion.removeClass( 'active' );
				$content.slideUp( 300 );
			} else {
				// jQuery( '.mobile-accordian' ).removeClass( 'active' );
				// jQuery( '.mobile-posts' ).slideUp( 300 );
				$accordion.addClass( 'active' );
				$content.slideDown( 300 );
			}
		} );
	}

	jQuery.noConflict();

	/**
	 * Toggle menu for mobile
	 */

	jQuery( '.menu-item-has-children > a, .menu-item-has-children > span' ).focus( function() {
		jQuery( this ).siblings( '.sub-sub-menu-item' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).siblings( '.sub-sub-menu-item' ).removeClass( 'focused' );
	} );

	// For children
	jQuery( '.sub-sub-menu-item a, .sub-sub-menu-item span' ).focus( function() {
		jQuery( this ).parents( '.sub-sub-menu-item' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).parents( '.sub-sub-menu-item' ).removeClass( 'focused' );
	} );

	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
		jQuery( 'header' ).removeClass( 'open' );
	} );

	jQuery.noConflict();

	jQuery( '.menu-accordion' ).siblings( 'ul' ).hide( );

	jQuery( '.menu-accordion' ).on( 'click', function( event ) {
		event.stopPropagation();
		jQuery( this ).removeClass( 'active-heading' );
		const $ul = jQuery( this ).next( 'ul' );
		if ( $ul.is( ':visible' ) ) {
			jQuery( this ).removeClass( 'active-heading' );
			$ul.slideUp( 300 );
		} else {
			jQuery( this ).parents( '.mega-menu-tiles' ).find( '.menu-accordion' ).removeClass( 'active-heading' );
			jQuery( this ).addClass( 'active-heading' );
			jQuery( '.menu-accordion' ).siblings( 'ul' ).slideUp( 300 );
			$ul.slideDown( 300 );
		}
	} );

	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first, span:first' )
				.after( '<span class="submenu-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none"><path d="M1 25L13.0336 12.9626L1.07464 1" style="stroke: #4A6587;"/></svg></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav li' ).click( function() {
		const link = jQuery( this );
		const menuItem = link.closest( 'li' );
		const megaDropdown = menuItem.find( '.mega-dropdown' );
		const linkStatus = menuItem.hasClass( 'active' );

		// Slide up all other open mega-dropdowns
		menuItem.siblings().removeClass( 'active' ).find( '.mega-dropdown' ).slideUp( 0 );
		menuItem.siblings().find( 'ul' ).slideUp( 0 );

		// Slide down the appropriate dropdown
		if ( ! linkStatus ) {
			if ( megaDropdown.length ) {
				megaDropdown.slideDown( 0 );
			} else {
				menuItem.children( 'ul' ).slideDown( 0 );
			}
			menuItem.addClass( 'active' );
		} else {
			if ( megaDropdown.length ) {
				megaDropdown.slideUp( 0 );
			} else {
				menuItem.children( 'ul' ).slideUp( 0 );
			}
			menuItem.removeClass( 'active' );
		}
	} );

	jQuery( document ).on( 'click', '.close-dropdown', function() {
		const element = jQuery( this ).parents( 'li.menu-item-has-children' ).find( '.mega-dropdown' );
		const li = jQuery( this ).parents( 'li.menu-item-has-children' );
		if ( element.hasClass( 'active-dropdown' ) ) {
			element.removeClass( 'active-dropdown' );
			li.removeClass( 'no-hover' );
			element.addClass( 'hide-dropdown' );
		}
	} );

	jQuery.noConflict();

	// if ( jQuery( window ).width() > 1003 ) {
	jQuery( '.logo-grid-content' ).on( 'init', function( event, slick ) {
		jQuery( '.logo-grid-content .slick-slide.slick-current' ).addClass( 'is-active' );
	} ).slick( {
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: false,
		arrows: false,
		touchThreshold: 100,
		variableWidth: true,
		focusOnSelect: false,
		speed: 300,
		autoWidth: true,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
	} );

	jQuery( '.logo-grid-logos' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		touchThreshold: 100,
		fade: true,
		speed: 400,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
		dots: false,
		arrows: false,
	} );

	jQuery( '.logo-grid-logos' ).on( 'afterChange', function( event, slick, currentSlide ) {
		jQuery( '.logo-grid-content' ).slick( 'slickGoTo', currentSlide );
		const currrentNavSlideElem = '.logo-grid-content .slick-slide[data-slick-index="' + currentSlide + '"]';
		jQuery( '.logo-grid-content .slick-slide.is-active' ).removeClass( 'is-active' );
		jQuery( currrentNavSlideElem ).addClass( 'is-active' );
	} );

	jQuery( '.logo-grid-content' ).on( 'click', '.slick-slide', function( event ) {
		event.preventDefault();
		const goToSingleSlide = jQuery( this ).data( 'slick-index' );
		jQuery( '.logo-grid-logos' ).slick( 'slickGoTo', goToSingleSlide );
	} );
	// }

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.features-faq > span' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).closest( '.features-faq' ).removeClass( 'active' );
				jQuery( this )
					.siblings( '.features-faq-content' )
					.slideUp( 300 );
			} else {
				jQuery( '.features-faq span' ).removeClass( 'active' );
				jQuery( '.features-faq' ).removeClass( 'active' );
				jQuery( this ).closest( '.features-faq' ).addClass( 'active' );
				jQuery( '.features-faq-content' ).slideUp( 300 );
				jQuery( this ).addClass( 'active' );
				jQuery( this )
					.siblings( '.features-faq-content' )
					.slideDown( 300 );
			}
		} );
	}

	jQuery.noConflict();

	jQuery( '.faq > span' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).closest( '.faq' ).removeClass( 'active' );
			jQuery( this )
				.siblings( '.faq-content' )
				.slideUp( 300 );
		} else {
			jQuery( '.faq span' ).removeClass( 'active' );
			jQuery( '.faq' ).removeClass( 'active' );
			jQuery( this ).closest( '.faq' ).addClass( 'active' );
			jQuery( '.faq-content' ).slideUp( 300 );
			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings( '.faq-content' )
				.slideDown( 300 );
		}
	} );

	jQuery.noConflict();

	jQuery( '.filter_single > span' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).closest( '.filter_single' ).removeClass( 'active' );
			jQuery( this )
				.siblings( '.filter__content' )
				.slideUp( 300 );
		} else {
			jQuery( '.filter_single span' ).removeClass( 'active' );
			jQuery( '.filter_single' ).removeClass( 'active' );
			jQuery( this ).closest( '.filter_single' ).addClass( 'active' );
			jQuery( '.filter__content' ).slideUp( 300 );
			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings( '.filter__content' )
				.slideDown( 300 );
		}
	} );

	jQuery.noConflict();

	function moveLogosSlider() {
		// Check if the screen width is under 748 pixels
		if ( jQuery( window ).width() < 1004 ) {
			// Move the .hero-logos-slider between .hero-text and .home-hero-image
			// jQuery( '.filter' ).after( jQuery( '.applied-filters' ) );
			jQuery( '.applied-filter-title' ).after( jQuery( '.clear-btn' ) );
		}
	}

	// Initial call to set the initial state
	moveLogosSlider();

	// Bind the function to the window resize event
	jQuery( window ).resize( moveLogosSlider );

	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.filter > .filter-head' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).closest( '.filter' ).removeClass( 'active' );
				jQuery( this )
					.siblings( '.filter-faqs' )
					.slideUp( 300 );
			} else {
				jQuery( '.filter .filter-head' ).removeClass( 'active' );
				jQuery( '.filter' ).removeClass( 'active' );
				jQuery( this ).closest( '.filter' ).addClass( 'active' );
				jQuery( '.filter-faqs' ).slideUp( 300 );
				jQuery( this ).addClass( 'active' );
				jQuery( this )
					.siblings( '.filter-faqs' )
					.slideDown( 300 );
			}
		} );
	}

	jQuery.noConflict();

	const table = jQuery( '#pricingTable' );
	const accordion = jQuery( '.ppf-accordion' );

	jQuery( window ).scroll( function() {
		const header = table.find( 'thead' );
		if ( ! header.length ) {
			// The header element doesn't exist, exit early
			return;
		}

		const tableOffset = table.offset().top;
		const accordionBottom = accordion.offset().top + accordion.outerHeight();

		if ( jQuery( window ).scrollTop() >= tableOffset && jQuery( window ).scrollTop() < accordionBottom ) {
			if ( jQuery( 'body' ).hasClass( 'logged-in admin-bar' ) ) {
				header.css( { position: 'sticky', top: 162 } );
			} else {
				header.css( { position: 'sticky', top: 124 } );
				if ( jQuery( window ).width() < 1180 ) {
					header.css( { position: 'sticky', top: 112 } );
				}
			}
		} else {
			header.css( { position: 'static' } );
		}
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() > 747 ) {
		jQuery( '.ppf-accordion > span' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).closest( '.ppf-accordion' ).removeClass( 'active' );
				jQuery( this )
					.siblings( '.ppf-table' )
					.slideUp( 500 );
			} else {
				jQuery( '.ppf-accordion span' ).removeClass( 'active' );
				jQuery( '.ppf-accordion' ).removeClass( 'active' );
				jQuery( this ).closest( '.ppf-accordion' ).addClass( 'active' );
				jQuery( '.ppf-table' ).slideUp( 500 );
				jQuery( this ).addClass( 'active' );
				jQuery( this )
					.siblings( '.ppf-table' )
					.slideDown( 500 );
			}
		} );
		jQuery( '.ppf-accordion > span' ).eq( 0 ).trigger( 'click' );
	}

	jQuery.noConflict();

	jQuery( '.welcome-content' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		asNavFor: '.welcome-images',
	} );

	jQuery( '.welcome-images' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		asNavFor: '.welcome-content',
		arrows: false,
		fade: true,
		cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
	} );

	jQuery.noConflict();

	jQuery( '.stats-slides' ).slick( {
		dots: true,
		infinite: true,
		fade: true,
		cssEase: 'ease-in-out',
		autoplay: true,
		autoplaySpeed: 4000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
	} );

	jQuery.noConflict();

	jQuery( '.logos-scroll-slider' ).slick( {
		arrows: false,
		variableWidth: true,
		speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		infinite: true,
	} );
	jQuery.noConflict();

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );

	// Style Variations
	const modeOptions = jQuery( 'input[name="mode"]' );
	const body = jQuery( 'body' );

	// Function to update the mode based on the selected radio button
	function updateMode() {
		const selectedMode = modeOptions.filter( ':checked' ).attr( 'id' );

		body.removeClass( 'dark-mode light-dark-mode high-contrast-mode' );

		if ( selectedMode === 'dark-mode' ) {
			body.addClass( 'dark-mode' );
			localStorage.setItem( 'mode', 'dark-mode' );
		} else if ( selectedMode === 'light-dark-mode' ) {
			body.addClass( 'light-dark-mode' );
			localStorage.setItem( 'mode', 'light-dark-mode' );
		} else if ( selectedMode === 'high-contrast-mode' ) {
			body.addClass( 'high-contrast-mode' );
			localStorage.setItem( 'mode', 'high-contrast-mode' );
		} else {
			// Default to light mode if no radio button is selected
			body.addClass( 'light-mode' );
			localStorage.setItem( 'mode', 'light-mode' );
		}
	}

	// Check local storage for user preference
	const userPreference = localStorage.getItem( 'mode' );
	if ( userPreference ) {
		modeOptions.filter( `#${ userPreference }` ).prop( 'checked', true );
		updateMode();
	}

	// Handle radio button change events
	modeOptions.change( updateMode );

	function adjustPaddingOnResize() {
		const heights = [];
		jQuery( '.speaker-content h3' ).attr( 'style', '' );
		jQuery( '.speaker-content h3' ).each( function() {
			heights.push( jQuery( this ).height() );
		} );
		const max = Math.max.apply( Math, heights );
		jQuery( '.speaker-content h3' ).css( 'height', max );
	}
	jQuery( window ).on( 'load', adjustPaddingOnResize );
	jQuery( window ).on( 'resize', adjustPaddingOnResize );

	function adjustPaddingOnResizenew() {
		const heights = [];
		jQuery( '.speaker-content p' ).attr( 'style', '' );
		jQuery( '.speaker-content p' ).each( function() {
			heights.push( jQuery( this ).height() );
		} );
		const max = Math.max.apply( Math, heights );
		jQuery( '.speaker-content p' ).css( 'height', max );
	}
	jQuery( window ).on( 'load', adjustPaddingOnResizenew );
	jQuery( window ).on( 'resize', adjustPaddingOnResizenew );

	jQuery( '.block-acf-info-tiles' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-hidden' );
} );

jQuery( document ).mouseup( function( e ) {
	const container = jQuery( '.search-form-new' );
	// if the target of the click isn't the container nor a descendant of the container
	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
		jQuery( '.search-form-new' ).slideUp();
	}
} );
